import { faCoin } from '@fortawesome/pro-duotone-svg-icons'
import { Stack } from '@mui/material'
import { memo } from 'react'

import Popup from 'src/components/shared/popup/Popup'
import DisplayValue from 'src/components/shared/text/DisplayValue'
import Text from 'src/components/shared/text/Text'
import { formatTicks } from 'src/util/string.helpers'

const ConfirmSymbolClaimPopup = ({
  symbol,
  onSubmit,
  onCancel,
  t,
  value,
  loading,
  error,
  stakingValue
}) => {
  const formattedValue = formatTicks(value)
  return (
    <Popup
      title={t('brand:staking.confirm-claim', { symbol })}
      description={t('brand:staking.confirm-claim-desc', { symbol })}
      submitLabel={t('common.confirm')}
      onFormSubmit={onSubmit}
      onCancel={onCancel && onCancel}
      cancelLabel={t('common.cancel')}
      submitBtnProps={{ loading }}
      icon={faCoin}
      disableClose
    >
      <Stack spacing={1} sx={{ py: { xs: 1, md: 1 } }}>
        <DisplayValue title={`${formattedValue} ${symbol}`} />
        <Text
          label={t('brand:staking.the-other-option', { value: stakingValue })}
        />
        {error && <Text label={t(error)} color='error' />}
      </Stack>
    </Popup>
  )
}

export default memo(ConfirmSymbolClaimPopup)
